'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Card security code input used for adding a card
                                                                                                                                                                                                                                                                   */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTextInput = require('react-text-input');

var _reactTextInput2 = _interopRequireDefault(_reactTextInput);

var _propValidators = require('prop-validators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STYLES = {
	errorMessage: {
		WebkitTransition: 'all 0.25s ease-in-out',
		MozTransition: 'all 0.25s ease-in-out',
		msTransition: 'all 0.25s ease-in-out',
		OTransition: 'all 0.25s ease-in-out',
		transition: 'all 0.25s ease-in-out'
	}
};

var CardSecurityCode = _react2.default.createClass({
	displayName: 'CardSecurityCode',

	propTypes: {
		cardSpec: _propValidators.cardSpecPropType,
		label: _react.PropTypes.string.isRequired,
		errorMessage: _react.PropTypes.string,
		handleChangeSecurityCode: _react.PropTypes.func.isRequired,
		handleFocus: _react.PropTypes.func,
		handleBlur: _react.PropTypes.func,
		dir: _react.PropTypes.string
	},

	getDefaultProps: function getDefaultProps() {
		return {
			handleFocus: function handleFocus() {},
			handleBlur: function handleBlur() {}
		};
	},
	getInitialState: function getInitialState() {
		return { showIsRequiredError: false };
	},


	/**
  * Handle changing the csc
  * @param {String} securityCode - the csc
  * @return {String} securityCode - numbers only
  */
	handleChangeSecurityCode: function handleChangeSecurityCode(securityCode) {
		securityCode = securityCode.replace(/\D+/g, '');
		this.handleCheckForValue(securityCode);
		this.props.handleChangeSecurityCode(securityCode);
		return securityCode;
	},


	/**
  * Check for a security code value
  * If the field is required, we should show that this field needs a value
  * @param {String} securityCode - the csc
  */
	handleCheckForValue: function handleCheckForValue(securityCode) {
		var cscSpecs = this.props.cardSpec.fields.csc;
		var isRequired = cscSpecs.required;
		this.setState({ showIsRequiredError: isRequired && !securityCode });
	},


	/**
  * Call parent's handleFocus
  * @param {String} securityCode - the csc
  */
	handleFocus: function handleFocus(securityCode) {
		this.props.handleFocus(securityCode);
	},


	/**
  * Check for a security code value and call parent's handleBlur
  * @param {String} securityCode - the csc
  */
	handleBlur: function handleBlur(securityCode) {
		this.handleCheckForValue(securityCode);
		this.props.handleBlur(securityCode);
	},
	render: function render() {
		var cscSpecs = this.props.cardSpec.fields.csc;
		var helpText = '●'.repeat(cscSpecs.maxlength);
		var errorMessage = this.props.errorMessage;

		var errorStyles = {
			height: 0,
			padding: 0
		};
		if (errorMessage) {
			errorStyles = { height: '100%' };
		}

		return _react2.default.createElement(
			'div',
			{ className: (0, _classnames2.default)({
					'vx_has-error-with-message': errorMessage,
					'vx_has-error': !errorMessage && this.state.showIsRequiredError
				}), style: { margin: '10px 0 0', position: 'relative' } },
			_react2.default.createElement(_reactTextInput2.default, { type: 'tel',
				id: 'securityCode',
				name: 'securityCode',
				className: 'vx_form-control vx_form-control_complex',
				label: this.props.label,
				helpText: helpText,
				maxlength: cscSpecs.maxlength,
				pattern: cscSpecs.pattern,
				required: cscSpecs.required,
				handleChange: this.handleChangeSecurityCode,
				handleFocus: this.handleFocus,
				handleBlur: this.handleBlur,
				dir: this.props.dir }),
			_react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)({
						'vx_form-control-message': errorMessage
					}), style: _extends({}, STYLES.errorMessage, { errorStyles: errorStyles }) },
				errorMessage
			)
		);
	}
});

exports.default = CardSecurityCode;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/react-card-security-code/dist/index.js
// module id = 584
// module chunks = 3